import { callApi } from './http'

export function questionnaireDeliverUserList(payload) {
  return callApi('post', 'questionnaire/deliver-user-list', payload)
}

export function questionnaireDeliverList(payload) {
  return callApi('post', 'questionnaire/deliver-list', payload)
}

export function questionnaireDeliver(payload) {
  return callApi('post', 'questionnaire/deliver', payload)
}

export function questionnairePartItemsEdit(payload) {
  return callApi('post', 'questionnaire/edit-part-items', payload)
}

export function questionnaireList(payload) {
  return callApi('post', 'questionnaire/list', payload)
}

export function questionnairePartList(payload) {
  return callApi('post', 'questionnaire/part-list', payload)
}

export function getQuestionnaire(payload) {
  return callApi('post', 'questionnaire/info', payload)
}

export function questionnairePartInfo(payload) {
  return callApi('post', 'questionnaire/part-info', payload)
}

export function questionnairePartCopy(payload) {
  return callApi('post', 'questionnaire/copy-part', payload)
}

export function createQuestionnaire(payload) {
  return callApi('post', 'questionnaire/create', payload)
}

export function editPartQuestionnaire(payload) {
  return callApi('post', 'questionnaire/edit-part', payload)
}

export function publishQuestionnaire(payload) {
  return callApi('post', 'questionnaire/publish', payload)
}

export function editQuestionnaire(payload) {
  return callApi('post', 'questionnaire/edit', payload)
}

export function deleteQuestionnaire(payload) {
  return callApi('post', 'questionnaire/delete', payload)
}
export function archiveQuestionnaire(payload) {
  return callApi('post', 'questionnaire/archive', payload)
}

export function getFillInList(payload) {
  return callApi('post', 'questionnaire/fill-in-list', payload)
}

export function getFillInInfo(payload) {
  return callApi('post', 'questionnaire/fill-in-info', payload)
}

export function getFormList(payload) {
  return callApi('post', 'questionnaire/form-list', payload)
}

export function editFormList(payload) {
  return callApi('post', 'questionnaire/edit-form-list', payload)
}

export function uploadImage(payload) {
  return callApi('post', 'questionnaire/upload-image', payload)
}

export function getFillInData(payload) {
  return callApi('post', 'questionnaire/fill-in-data', payload)
}

export function editFillIn(payload) {
  return callApi('post', 'questionnaire/edit-fill-in', payload)
}

export function getReportList(payload) {
  return callApi('post', 'questionnaire/report', payload)
}

export function copyQuestionnaire(payload) {
  return callApi('post', 'questionnaire/copy', payload)
}

export function downloadQuestionnaire(payload) {
  return callApi('post', 'questionnaire/download', payload)
}

export function deleteFormList(payload) {
  return callApi('post', 'questionnaire/delete-form-list', payload)
}

export function deleteResult(payload) {
  return callApi('post', 'questionnaire/delete-fill-in-list', payload)
}
